import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/demo/shared/shared.module';
import { AccountService } from 'src/app/tabms/services/admin/account/account.service';
import { SessionWrapperService } from 'src/app/tabms/services/session/session-wrapper.service';
import { branchesDto, userBranches } from 'src/app/tabms/models/admin/branch';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import { Subject, takeUntil } from 'rxjs';
import { RTL } from 'src/app/@theme/const';
import { ApiSessionService } from 'src/app/tabms/services/global/api-session.service';

@Component({
  selector: 'app-change-branch',
  standalone: true,
  imports: [CommonModule, SharedModule],
  templateUrl: './change-branch.component.html',
  styleUrl: './change-branch.component.scss'
})
export class ChangeBranchComponent implements OnInit, OnDestroy {
  selectedBranch;
  branchsData: userBranches[];
  currentLang: string;

  private destroy$: Subject<void> = new Subject<void>();
  constructor(
    private accountService: AccountService,
    private sessionService: SessionWrapperService,
    private baseService: BaseService,
    private themeLayout: ThemeLayoutService,
    private apiSession: ApiSessionService
  ) {
    this.currentLang = this.baseService.getCurrentLanguage();

    this.themeLayout.directionChange.pipe(takeUntil(this.destroy$)).subscribe({
      next: (dir) => {
        (dir === RTL) ? this.currentLang = 'ar' : this.currentLang = 'en';
      }
    })
  }

  ngOnInit(): void {
    let session = this.sessionService.getsessionData();
    this.accountService.GetBranchesByUser(session.userid).subscribe({
      next: (res) => {
        if (res) {
          this.branchsData = res.result;
          let defaultBranch: branchesDto = this.sessionService.getDefaultBranch();
          this.selectedBranch = defaultBranch.id;
        }
      },
      error: (err) => {
      }
    });
  }



  branchSelect(branchId: string) {
    this.selectedBranch = branchId;
    let branchObj = this.branchsData.find(x => x.id == branchId);
    this.sessionService.setDefaultBranch(branchObj); //set on browser session
    this.apiSession.changeUserCurrentBranch(branchId); //send to api session
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
